var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSharedFiles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.32132 19.6H12.6795C17.5286 19.6 19.6004 17.5282 19.6004 12.6791V10.893C19.6004 10.5269 19.2968 10.2233 18.9306 10.2233C18.5645 10.2233 18.2609 10.5269 18.2609 10.893V12.6791C18.2609 16.7959 16.7963 18.2605 12.6795 18.2605H7.32132C3.20448 18.2605 1.73993 16.7959 1.73993 12.6791V7.32092C1.73993 3.20409 3.20448 1.73953 7.32132 1.73953H9.10737C9.47351 1.73953 9.77714 1.4359 9.77714 1.06976C9.77714 0.703622 9.47351 0.399994 9.10737 0.399994H7.32132C2.4722 0.399994 0.400391 2.47181 0.400391 7.32092V12.6791C0.400391 17.5282 2.4722 19.6 7.32132 19.6ZM18.9306 6.02604C18.5645 6.02604 18.2609 5.72241 18.2609 5.35627V2.68612L11.3667 9.58027C11.2328 9.71422 11.0631 9.77673 10.8934 9.77673C10.7237 9.77673 10.5541 9.71422 10.4201 9.58027C10.1611 9.32129 10.1611 8.89264 10.4201 8.63366L17.3142 1.73953H14.6441C14.278 1.73953 13.9744 1.4359 13.9744 1.06976C13.9744 0.703622 14.278 0.399994 14.6441 0.399994H18.9306C19.2968 0.399994 19.6004 0.703622 19.6004 1.06976V5.35627C19.6004 5.72241 19.2968 6.02604 18.9306 6.02604Z",
    fill: "#5A5C61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedFiles);
export default __webpack_public_path__ + "static/media/shared-files.9ebd710056345a28ae2ab79e1a2948bd.svg";
export { ForwardRef as ReactComponent };